import { endpoint } from 'services/endpoint';
import { http, httpQ4US } from 'services/http';
import {
	TDownloadSwissDeclarationRequest,
	TOrderListRequest,
	TSwissDeclarationsRequest,
} from 'redux/reducers/orderManagement/types';
import { TOrderManagementApi } from './types';

export const orderManagement: TOrderManagementApi = {
	getOrderList: (payload: TOrderListRequest) =>
		httpQ4US
			.post(endpoint.orderManagement.GET_ORDER_LIST, payload)
			.then((response) => response.data),
	getOrderSplits: (id: number) =>
		httpQ4US.get(endpoint.orderManagement.GET_ORDER_SPLITS(id)).then((response) => response.data),
	getOrderItems: (id: number) =>
		httpQ4US.get(endpoint.orderManagement.GET_ORDER_ITEMS(id)).then((response) => response.data),
	getSplitItemsBySplitId: (splitId: string) =>
		httpQ4US
			.get(endpoint.orderManagement.GET_SPLIT_ITEMS(splitId))
			.then((response) => response.data),
	getOrderReturns: (payload: TOrderListRequest) =>
		httpQ4US
			.post(endpoint.orderManagement.GET_ORDER_LIST, payload)
			.then((response) => response.data),
	getOrderReturnItems: (payload: TOrderListRequest) =>
		httpQ4US
			.post(endpoint.orderManagement.GET_ORDER_LIST, payload)
			.then((response) => response.data),
	getOrderDiscounts: (payload: TOrderListRequest) =>
		httpQ4US
			.post(endpoint.orderManagement.GET_ORDER_DISCOUNTS, payload)
			.then((response) => response.data),
	getOrderDiscountBreakdown: (payload: TOrderListRequest) =>
		httpQ4US
			.post(endpoint.orderManagement.GET_ORDER_DISCOUNT_BREAKDOWN, payload)
			.then((response) => response.data),
	getSwissDeclarations: (payload: TSwissDeclarationsRequest) =>
		http
			.get(endpoint.orderManagement.GET_SWISS_DECLARATIONS(payload.orderId), {
				params: {
					PageSize: payload.pageSize,
					PageNumber: payload.pageNumber,
				},
			})
			.then((response) => response.data),
	downloadSwissDeclaration: (payload: TDownloadSwissDeclarationRequest) =>
		http
			.get(endpoint.orderManagement.GET_SWISS_DECLARATION(payload.orderId, payload.id), {
				responseType: 'blob',
			})
			.then((response) => response.data),
};
